module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step1b_Image6.0d83600f.jpg";